import { css } from "@emotion/react";
import { ITheme } from ".";

export const global = (theme: ITheme) =>
    css([
        {
            body: {
                fontFamily: '"Roboto", sans-serif',

                color: theme.foreground,
                backgroundColor: theme.backgroundPage,

                borderTop: `solid 3px ${theme.brandKey} !important`,
                position: "relative", // start content below top border,

                "input, textarea, select, button": {
                    fontFamily: '"Roboto", sans-serif'
                },

                h1: {
                    color: "inherit"
                },
                "h2.title": {
                    color: theme.foregroundTitle
                },

                "input[type='file']": {
                    "&::file-selector-button": {
                        padding: "5px 8px",
                        backgroundColor: theme.neutral1,
                        borderRadius: 3,
                        cursor: "pointer"
                    }
                }
            }
        }
    ]);
